import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { useState } from 'react';
import { bool, shape, func, string } from 'prop-types';
import { isInternationalPrice } from '../../utils';
import Sidebar, { SidebarHeader } from '../Sidebar';
import TagInternational from '../TagInternational';
import ContentBox from './content-box';
import ImportDetails from './import-details';
import { DialogContainer } from './import-taxes.styles';

const ImportTaxes = _ref => {
  let {
    product,
    onDetailsOpen,
    onDetailsClose,
    isIncludeTaxes,
    isMobile
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["product", "onDetailsOpen", "onDetailsClose", "isIncludeTaxes", "isMobile"]);

  const [showDetails, setShowDetails] = useState(false);
  const showInternationalPurchase = isInternationalPrice(product == null ? void 0 : product.price);

  const openDetails = e => {
    onDetailsOpen(e);
    setShowDetails(true);
  };

  const closeDetails = e => {
    onDetailsClose(e);
    setShowDetails(false);
  };

  if (!showInternationalPurchase) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TagInternational, {
    variant: "small"
  }), /*#__PURE__*/React.createElement(ContentBox, _extends({
    onLinkClick: openDetails,
    isIncludeTaxes: isIncludeTaxes
  }, props)), isMobile && /*#__PURE__*/React.createElement(Sidebar, {
    direction: "right",
    visible: showDetails,
    onClickOutside: closeDetails,
    fullScreen: false
  }, /*#__PURE__*/React.createElement(SidebarHeader, {
    label: "Compra Internacional",
    align: "left",
    fontSize: 3,
    leftButton: {
      icon: 'back',
      title: 'Voltar para a página do produto',
      onClick: closeDetails
    }
  }), /*#__PURE__*/React.createElement(ImportDetails, {
    isMobile: true,
    closeDetails: closeDetails
  })), !isMobile && /*#__PURE__*/React.createElement(DialogContainer, {
    visible: showDetails,
    onClickOutside: closeDetails,
    position: "center",
    showHorizontalRule: true,
    title: "Compra Internacional",
    showClose: true
  }, /*#__PURE__*/React.createElement(ImportDetails, {
    closeDetails: closeDetails
  })));
};

process.env.NODE_ENV !== "production" ? ImportTaxes.propTypes = {
  product: shape({
    price: shape({
      currency: string
    })
  }),
  isMobile: bool,
  isIncludeTaxes: bool,
  onDetailsOpen: func,
  onDetailsClose: func
} : void 0;
ImportTaxes.defaultProps = {
  product: {},
  isMobile: false,
  isIncludeTaxes: false,
  onDetailsOpen: () => {},
  onDetailsClose: () => {}
};
export default ImportTaxes;